import { render, staticRenderFns } from "./CompetitionBanner.vue?vue&type=template&id=e9bc9d16"
import script from "./CompetitionBanner.vue?vue&type=script&lang=js"
export * from "./CompetitionBanner.vue?vue&type=script&lang=js"
import style0 from "./CompetitionBanner.vue?vue&type=style&index=0&id=e9bc9d16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports